import { memo, useCallback, useState } from 'react';
import { Box, Skeleton, Typography } from '@mui/material';
// Local files
import BaseDialog from 'components/Common/Feedback/BaseDialog/BaseDialog';
import FilePreview from 'components/Common/FilePreview/FilePreview';
import BaseEventsList from 'components/Analyses/Common/BaseEventsList/BaseEventsList';
import useSuperbillTasks from 'hooks/useSuperbillTasks';
import useEvents from 'hooks/useEvents';
import useCustomSelector from 'hooks/useCustomSelector';
import { superbillTasksSelectors } from "features/superbillTasks";
import { eventsSelectors } from "features/events";

const SuperbillTask = ({ open, taskId, onClose }) => {
  const { getSuperbillTask, clearLocalActiveSuperbillTask } = useSuperbillTasks();
  const { getSuperbillTasksEvents, clearLocalTasksEvents } = useEvents();
  const { result } = useCustomSelector(superbillTasksSelectors.getSuperbillTaskData);
  const fetching = useCustomSelector(superbillTasksSelectors.superbillTaskIsFetching);
  const { data, pagination } = useCustomSelector(eventsSelectors.getTasksEventsData);
  const eventsFetching = useCustomSelector(eventsSelectors.taskEventsIsFetching);
  const [expanded, setExpanded] = useState(false);
  const [firstTimeEventsOpened, setFirstTimeEventsOpened] = useState(true);

  const fetchSuperbillTasksEvents = useCallback((offset, taskId) => {
    getSuperbillTasksEvents({ offset, superbill_task_id: taskId })
  }, [ getSuperbillTasksEvents]);

  const handleChangeExpand = (_, isExpanded) => {
    setExpanded(isExpanded);
    if (firstTimeEventsOpened) {
      fetchSuperbillTasksEvents(0, taskId);
      setFirstTimeEventsOpened(false);
    }
  }
  const handleEntering = () => {
    getSuperbillTask(taskId);
  };
  const handleExited = () => {
    setExpanded(false);
    setFirstTimeEventsOpened(true);
    clearLocalActiveSuperbillTask();
    clearLocalTasksEvents();
  };

  return (
    <BaseDialog
      open={open}
      onClose={onClose}
      TransitionProps={{ onExited: handleExited, onEntering: handleEntering }}
      otherPaperStyle={{ width: '100%', maxWidth: 800, backgroundColor: 'background.default' }}
      title='Task'
    >
      {fetching ? <Skeleton/> : <Box sx={{ px: 4, pb: 3 }}>
        {result?.id && <Box sx={{ mb: '30px' }}>
          <Typography sx={{ fontSize: '1rem', fontWeight: 400, mb: '10px' }}>File:</Typography>
          <FilePreview
            key={result?.id}
            type={result?.content_type}
            name={result?.filename}
            url={result?.url}
          />
        </Box>}
        <BaseEventsList
          data={data}
          pagination={pagination}
          analysisId={taskId}
          eventsFetching={eventsFetching}
          fetchEvents={fetchSuperbillTasksEvents}
          expanded={expanded}
          handleChangeExpand={handleChangeExpand}
          expandButton={false}
        />  
      </Box>}
    </BaseDialog>
  );
};

export default memo(SuperbillTask);